import React, { useState } from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import ExpenseImage from "../../assets/img/ExpensesManagement.jpg";
import AnimatedCard from "react-animated-3d-card";

export default function SummaryCard({ totalBalance, currency }) {
  const history = useHistory();
  const [transformStyle, setTransformStyle] = useState({});
  const [isHovered, setIsHovered] = useState(false);
  const OnExpenseClick = () => {
    history.push("/expenses");
  };
  return (
    <>
      <div className="bg-white-500 shadow">
        <div className="aminated-card h-full w-full">
          <div onClick={OnExpenseClick}>
            <AnimatedCard
              config={{
                rotation: 30,
                transformSpeed: 1000,
                transitionSpeed: 600,
              }}
              style={{
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "none",
                borderRadius: "0.5rem",
                padding: "8px 15px",
              }}
            >
              <div className="text-center mt-3">
                <div className="text-center mt-3">
                  <span className="text-xl block">Expenses</span>
                  <span className="text-xl block">Management</span>
                </div>
              </div>
              {/* <h2 className="text-blueGray-700 text-xl font-semibold text-center h-full w-full pt-3"></h2> */}
              <img
                src={ExpenseImage}
                alt="Quantity Tracking"
                className="w-full h-auto object-cover pb-3"
              />
            </AnimatedCard>
          </div>
        </div>
      </div>
      <div className="inline-flex img-balance space-x-4">
        <div
          style={{ border: "solid 1px", cursor: "pointer" }}
          className=""
          title={`Total Available Balance (${currency}): ${
            totalBalance?.availableBalance ?? 0
          }`}
        >
          <span className="text-emerald-500 font-semibold">
            {totalBalance?.availableBalance ?? 0}
          </span>
        </div>
        <div
          className="transparent"
          style={{ border: "solid 1px", cursor: "pointer" }}
          title={`Total Credited (${currency}): ${
            totalBalance?.totalCreatedSum ?? 0
          }`}
        >
          <span className="text-orange-500 font-semibold">
            {totalBalance?.totalCreatedSum}
          </span>
        </div>
        <div
          className="transparent"
          style={{ border: "solid 1px", cursor: "pointer" }}
          title={`Total Debited (${currency}): ${
            totalBalance?.totalDebitedSum ?? 0
          }`}
        >
          <span className="text-red-500 font-semibold">
            {totalBalance?.totalDebitedSum}
          </span>
        </div>
      </div>
    </>
  );
}

SummaryCard.propTypes = {
  totalBalance: PropTypes.shape({
    availableBalance: PropTypes.number,
    totalCreatedSum: PropTypes.number,
    totalDebitedSum: PropTypes.number,
  }).isRequired,
  currency: PropTypes.string.isRequired,
};
